import { render, staticRenderFns } from "./HighEndTips.vue?vue&type=template&id=49b1105c&scoped=true&"
import script from "./HighEndTips.vue?vue&type=script&lang=js&"
export * from "./HighEndTips.vue?vue&type=script&lang=js&"
import style0 from "./HighEndTips.vue?vue&type=style&index=0&id=49b1105c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1105c",
  null
  
)

export default component.exports